import React from "react";
import { LordIcon } from "../global/globalIcon";

type YourIconProps = {
  size?: number;
  colors?: { primary?: string; secondary?: string };
  trigger?:
    | "hover"
    | "click"
    | "loop"
    | "loop-on-hover"
    | "morph"
    | "morph-two-way";
  delay?: number;
};

const SecurityIcon: React.FC<YourIconProps> = ({
  size = 24,
  colors = {},
  trigger = "hover",
  delay = 0,
}) => {
  return (
    <LordIcon
      src="/iconjson/security.json"
      size={size}
      colors={colors}
      trigger={trigger}
      delay={delay}
    />
  );
};

export default SecurityIcon;
